import SectionBecomeTutor from './SectionBecomeTutor';
export default SectionBecomeTutor;
